/** Пути к публичным ассетам относительно корня приложения. */
export const PUBLIC_AVATAR_URL = "/assets/avatar.png";
export const PUBLIC_FIRE_URL = "/assets/fire.png";
